import type { User } from '../types';

export const ZRMUserInfo = ({
  summary = {
    activeListingCount: 0,
    isPartialResponse: false,
    totalListingCount: 0,
  },
  isMultifamilyCustomer = false,
  isSingleFamilyEnterpriseCustomer = false,
}: User) => ({
  active_listing_cnt: Number(summary.activeListingCount),
  total_listing_cnt: Number(summary.totalListingCount),
  multi_family_customer_ind: Boolean(isMultifamilyCustomer),
  single_family_enterprise_customer_ind: Boolean(isSingleFamilyEnterpriseCustomer),
});
